/**
 * Email Value Object
 * Ensures email addresses are valid and provides type safety
 */
export class Email {
  private static readonly EMAIL_VALIDATION_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  private constructor(private readonly emailAddress: string) {}

  static fromEmailAddress(rawEmailAddress: string): Email {
    const normalizedEmailAddress = this.normalizeEmailAddress(rawEmailAddress);

    if (!this.isValidEmailFormat(normalizedEmailAddress)) {
      throw new Error(`Invalid email address format: ${rawEmailAddress}`);
    }

    return new Email(normalizedEmailAddress);
  }

  static isValidEmailFormat(emailAddress: string): boolean {
    return Email.EMAIL_VALIDATION_PATTERN.test(emailAddress);
  }

  getEmailAddress(): string {
    return this.emailAddress;
  }

  isEqualTo(otherEmail: Email): boolean {
    return this.emailAddress === otherEmail.emailAddress;
  }

  getDomainName(): string {
    return this.emailAddress.split('@')[1];
  }

  getLocalPart(): string {
    return this.emailAddress.split('@')[0];
  }

  formatForDisplay(): string {
    return this.emailAddress;
  }

  private static normalizeEmailAddress(rawEmailAddress: string): string {
    return rawEmailAddress.toLowerCase().trim();
  }
}
